import React, { Fragment } from 'react';
import {
  Grid,
  Accordion,
  Form,
  Icon,
  Button,
  Header,
  Divider,
} from 'semantic-ui-react';
import { Field } from 'redux-form';
import PropTypes from 'prop-types';

import { DirtyWrapper } from 'Components';
import { Filter, Main } from 'Containers';
import { InputField, SelectField } from 'Common/SemanticWrapper';
import { CreateEditTruckRouteEnum } from 'Common/FieldEnum';
import { getFilteredData } from 'Common/GridHelper';
import { ReduxFormButtonGroup } from 'Components/forms/ReduxFormButtonGroup';
import { CREATE_EDIT_TRUCK_ROUTE_FORM_NAME } from 'Common/FormEnum';
import {
  TruckRouteTypeEnum,
  AssignTypeEnum,
} from 'Common/Constants/Enumeration/TruckRouteEnum';

import { SiteGridContainer } from './../../containers/createedittruckroute/SiteGridContainer';
import { ItemGridContainer } from './../../containers/createedittruckroute/ItemGridContainer';
import { VendorGridContainer } from './../../containers/createedittruckroute/VendorGridContainer';

const CreateEditTruckRouteComponent = props => {
  const {
    getBreadCrumbs,
    filtered,
    onFilteredChange,
    activeIndexes,
    handleCollapsePanelClick,
    clearFilters,
    bidGroupOptions,
    itemGroupOptions,
    acctCategoryOptions,
    vendorData,
    storageLocationData,
    fetchingDropdown,
    siteGroupDataOptions,
    siteData,
    handleChange,
    siteGroupId,
    bidGroupId,
    itemGroup,
    vendorId,
    storageLocationId,
    accountCategory,
    initialSelectedSites,
    initialSelectedVendors,
    siteItems,
    siteItemsLoading,
    getMainProps,
    routeName,
    isNew,
    id,
    onChangeTypeOption,
    truckRouteType,
    handleAssignTypeChange,
    assignType,
    vendorTableData,
    vendorItemIdsLoading,
    vendorTableDataLoading,
    truckRouteAssignmentTypesOptions,
    truckRouteTypesOption,
  } = props;

  let newItemsData = [];
  let gridFilterValues = {};
  let newSiteData = [];
  let gridSiteFilterValues = {};

  if (bidGroupId) {
    gridFilterValues[CreateEditTruckRouteEnum.GroupId_Bid] = bidGroupId;
  }
  if (itemGroup) {
    gridFilterValues[CreateEditTruckRouteEnum.GroupId_Item] = itemGroup;
  }
  if (vendorId) {
    gridFilterValues[CreateEditTruckRouteEnum.VendorId] = vendorId;
  }
  if (storageLocationId) {
    gridFilterValues[
      CreateEditTruckRouteEnum.StorageLocationId
    ] = storageLocationId;
  }
  if (accountCategory) {
    gridFilterValues[CreateEditTruckRouteEnum.GroupId_Cat] = accountCategory;
  }
  newItemsData = getFilteredData(gridFilterValues, siteItems);

  if (siteGroupId) {
    gridSiteFilterValues[CreateEditTruckRouteEnum.SiteGroupId] = siteGroupId;
  }
  newSiteData = getFilteredData(gridSiteFilterValues, siteData);

  return (
    <Fragment>
      <Filter title={''} breadcrumbs={getBreadCrumbs()} />
      <DirtyWrapper>
        {showDirtyConfirm => (
          <Main {...getMainProps(showDirtyConfirm)} shouldNotUsePageWidth>
            <Form>
              <Grid>
                <Grid.Row columns={2}>
                  <Grid.Column width={7} style={{ marginBottom: 10 }}>
                    <Field
                      name={CreateEditTruckRouteEnum.RouteName}
                      component={InputField}
                      type="text"
                      maxLength={30}
                      label={'Route Name'}
                      style={{ width: '70%' }}
                    />
                  </Grid.Column>
                  <Grid.Column>
                    <ReduxFormButtonGroup
                      label={'Type'}
                      options={truckRouteTypesOption}
                      type={'button'}
                      formName={CREATE_EDIT_TRUCK_ROUTE_FORM_NAME}
                      fieldName={CreateEditTruckRouteEnum.Type}
                      onChange={onChangeTypeOption}
                    />
                  </Grid.Column>
                </Grid.Row>
                <Grid.Row>
                  <Grid.Column width={7}>
                    <Accordion fluid styled>
                      <Accordion.Title
                        active={activeIndexes.indexOf(0) !== -1}
                        index={0}
                        onClick={handleCollapsePanelClick}
                      >
                        <Icon name="dropdown" />
                        <span className="text-orange">Filter By</span>
                      </Accordion.Title>
                      <Accordion.Content
                        active={activeIndexes.indexOf(0) !== -1}
                      >
                        <Grid>
                          <Grid.Row>
                            <Grid.Column width={11}>
                              <Field
                                component={SelectField}
                                label={'Site Group'}
                                name={CreateEditTruckRouteEnum.SiteGroupId}
                                options={siteGroupDataOptions}
                                loading={fetchingDropdown}
                                onChange={handleChange}
                                disabled={
                                  assignType === AssignTypeEnum.Distributor
                                }
                              />
                            </Grid.Column>
                          </Grid.Row>
                        </Grid>
                      </Accordion.Content>
                    </Accordion>
                  </Grid.Column>
                  <Grid.Column width={9}>
                    <Accordion fluid styled>
                      <Accordion.Title
                        active={activeIndexes.indexOf(1) !== -1}
                        index={1}
                        onClick={handleCollapsePanelClick}
                      >
                        <Icon name="dropdown" />
                        <span className="text-orange">Filter By</span>
                      </Accordion.Title>
                      <Accordion.Content
                        active={activeIndexes.indexOf(1) !== -1}
                      >
                        <Grid>
                          <Grid.Row columns={2}>
                            <Grid.Column>
                              <Field
                                component={SelectField}
                                label={'Bid Group'}
                                name={CreateEditTruckRouteEnum.BidGroupId}
                                options={bidGroupOptions}
                                loading={fetchingDropdown}
                                onChange={handleChange}
                              />
                            </Grid.Column>
                            <Grid.Column>
                              <Field
                                component={SelectField}
                                label={'Item Group'}
                                name={CreateEditTruckRouteEnum.ItemGroup}
                                options={itemGroupOptions}
                                loading={fetchingDropdown}
                                onChange={handleChange}
                              />
                            </Grid.Column>
                          </Grid.Row>
                          <Grid.Row columns={2}>
                            <Grid.Column>
                              <Field
                                component={SelectField}
                                label={'Distributor'}
                                name={CreateEditTruckRouteEnum.VendorId}
                                options={vendorData}
                                loading={fetchingDropdown}
                                onChange={handleChange}
                              />
                            </Grid.Column>
                            <Grid.Column>
                              <Field
                                component={SelectField}
                                label={'Storage Location'}
                                name={
                                  CreateEditTruckRouteEnum.StorageLocationId
                                }
                                options={storageLocationData}
                                loading={fetchingDropdown}
                                onChange={handleChange}
                              />
                            </Grid.Column>
                          </Grid.Row>
                          <Grid.Row columns={2}>
                            <Grid.Column>
                              <Field
                                component={SelectField}
                                label={'Acct. Category'}
                                name={CreateEditTruckRouteEnum.AccountCategory}
                                options={acctCategoryOptions}
                                loading={fetchingDropdown}
                                onChange={handleChange}
                              />
                            </Grid.Column>
                            <Grid.Column verticalAlign={'bottom'}>
                              <Button
                                type="button"
                                content="Clear Filters"
                                className="clear-filter"
                                onClick={clearFilters}
                              />
                            </Grid.Column>
                          </Grid.Row>
                        </Grid>
                      </Accordion.Content>
                    </Accordion>
                  </Grid.Column>
                </Grid.Row>
                <Divider horizontal />
                <Grid.Row columns={2}>
                  <Grid.Column width={7}>
                    {truckRouteType === TruckRouteTypeEnum.Delivery ? (
                      <Header as="h3">Assign Sites</Header>
                    ) : (
                      <Field
                        component={SelectField}
                        name={CreateEditTruckRouteEnum.AssignType}
                        options={truckRouteAssignmentTypesOptions}
                        onChange={handleAssignTypeChange}
                        style={{ width: '70%' }}
                      />
                    )}
                    {truckRouteType !== TruckRouteTypeEnum.Delivery &&
                    assignType === AssignTypeEnum.Distributor ? (
                      <Field
                        component={VendorGridContainer}
                        name={CreateEditTruckRouteEnum.VendorIds}
                        {...{
                          allVendorsData: vendorTableData,
                          initialSelectedVendors: initialSelectedVendors,
                          loadingAllVendors: vendorTableDataLoading,
                          isNew,
                          id,
                        }}
                      />
                    ) : (
                      <Field
                        component={SiteGridContainer}
                        name={CreateEditTruckRouteEnum.SiteIds}
                        {...{
                          allSitesData: newSiteData,
                          initialSelectedSites: initialSelectedSites,
                          isNew,
                          id,
                        }}
                      />
                    )}
                  </Grid.Column>
                  <Grid.Column width={9}>
                    <Header as="h3">Assign Items</Header>
                    <Field
                      component={ItemGridContainer}
                      name={CreateEditTruckRouteEnum.ItemIds}
                      {...{
                        siteItemsLoading:
                          siteItemsLoading || vendorItemIdsLoading,
                        dataSource: newItemsData,
                        filtered,
                        onFilteredChange,
                        routeName,
                      }}
                    />
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            </Form>
          </Main>
        )}
      </DirtyWrapper>
    </Fragment>
  );
};

CreateEditTruckRouteComponent.propTypes = {
  getBreadCrumbs: PropTypes.func,
  filtered: PropTypes.array,
  onFilteredChange: PropTypes.func,
  activeIndexes: PropTypes.array,
  handleCollapsePanelClick: PropTypes.func,
  clearFilters: PropTypes.func,
  bidGroupOptions: PropTypes.array,
  itemGroupOptions: PropTypes.array,
  acctCategoryOptions: PropTypes.array,
  vendorData: PropTypes.array,
  storageLocationData: PropTypes.array,
  fetchingDropdown: PropTypes.bool,
  checked: PropTypes.bool,
  toggle: PropTypes.func,
  siteGroupDataOptions: PropTypes.array,
  siteData: PropTypes.array.isRequired,
  handleChange: PropTypes.func,
  siteGroupId: PropTypes.number,
  bidGroupId: PropTypes.number,
  itemGroup: PropTypes.number,
  vendorId: PropTypes.number,
  storageLocationId: PropTypes.number,
  accountCategory: PropTypes.number,
  initialSelectedSites: PropTypes.array,
  initialSelectedVendors: PropTypes.array,
  siteItems: PropTypes.array.isRequired,
  siteItemsLoading: PropTypes.bool,
  getMainProps: PropTypes.func,
  routeName: PropTypes.string,
  isNew: PropTypes.bool,
  id: PropTypes.string,
  onChangeTypeOption: PropTypes.func,
  truckRouteType: PropTypes.number,
  handleAssignTypeChange: PropTypes.func,
  assignType: PropTypes.number,
  vendorTableData: PropTypes.array,
  vendorItemIdsLoading: PropTypes.bool,
  vendorTableDataLoading: PropTypes.bool,
  truckRouteAssignmentTypesOptions: PropTypes.array,
  truckRouteTypesOption: PropTypes.array,
};
CreateEditTruckRouteComponent.defaultProps = {
  getBreadCrumbs: () => {},
  filtered: [],
  onFilteredChange: () => {},
  activeIndexes: [],
  handleCollapsePanelClick: () => {},
  clearFilters: () => {},
  bidGroupOptions: [],
  itemGroupOptions: [],
  acctCategoryOptions: [],
  vendorData: [],
  storageLocationData: [],
  fetchingDropdown: false,
  checked: false,
  toggle: () => {},
  siteGroupDataOptions: [],
  handleChange: () => {},
  siteGroupId: 0,
  bidGroupId: 0,
  itemGroup: 0,
  vendorId: 0,
  storageLocationId: 0,
  accountCategory: 0,
  initialSelectedSites: [],
  initialSelectedVendors: [],
  siteItemsLoading: false,
  getMainProps: () => {},
  routeName: '',
  isNew: false,
  id: 0,
  onChangeTypeOption: () => {},
  truckRouteType: TruckRouteTypeEnum.Delivery,
  handleAssignTypeChange: () => {},
  assignType: AssignTypeEnum.Sites,
  vendorTableData: [],
  vendorItemIdsLoading: false,
  vendorTableDataLoading: false,
  truckRouteAssignmentTypesOptions: [],
  truckRouteTypesOption: [],
};
export default CreateEditTruckRouteComponent;



// WEBPACK FOOTER //
// ./src/pages/inventory/truckroutes/components/createedittruckroute/CreateEditTruckRoute.js